import { filterNewApprovalPhotos, filterNewGalleryPhotos, getObjectFromValue, getValueFromObject } from '../Functions'
import update from 'immutability-helper'
import PostAcademyCategories from '../Components/Categories/PostAcademyCategories'
import ReunionCategories from '../Components/Categories/ReunionCategories'
import AcademyTimeframeOptions from '../Components/PhotoOptions/AcademyTimeframesOptions'
import DecadeOptions from '../Components/PhotoOptions/DecadeOptions'
import ReunionEventOptions from '../Components/PhotoOptions/ReunionEventOptions'
import Select, { createFilter } from 'react-select'
import React from 'react'

const TimeframesSearch = ({ state, setState, varNames }) => {
  const {
    [`${varNames.academyTimeframe}`]: academyTimeframe,
    [`${varNames.category}`]: category,
    [`${varNames.decade}`]: decade,
    [`${varNames.subsection}`]: subsection
  } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-timeframes'>
      {(() => {
        let newState
        let disabled = false
        let options = []
        let placeholder = 'Select a category...'
        let valueName = ''

        if (category === '') {
          disabled = true
        } else if (category === 'Academy Years') {
          newState = (value) => update(state, {
            [`${varNames.academyTimeframe}`]: { $set: getValueFromObject(value) || '' }
          })
          options = AcademyTimeframeOptions
          placeholder = 'Select a timeframe...'
          valueName = academyTimeframe
        } else if (PostAcademyCategories.includes(category)) {
          newState = (value) => update(state, {
            [`${varNames.decade}`]: { $set: getValueFromObject(value) || '' }
          })
          options = DecadeOptions
          placeholder = 'Select a timeframe...'
          valueName = decade
        } else if (ReunionCategories.includes(category)) {
          newState = (value) => update(state, {
            [`${varNames.subsection}`]: { $set: getValueFromObject(value) || '' }
          })
          options = ReunionEventOptions
          placeholder = 'Select an event...'
          valueName = subsection
        }

        return (
          <Select
            isClearable
            disabled={disabled}
            className='photos-search-container'
            onChange={(value) => {
              callbacks[`${varNames.callback}`]({
                state: ((value) => newState(value))(),
                setState,
                varNames
              })
            }}
            options={options}
            placeholder={placeholder}
            value={getObjectFromValue(valueName, options)}
            filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
          />
        )
      })()}
    </div>
  )
}

export default TimeframesSearch
